import { useState } from "react"
import { useRequest } from "ahooks";
import { Card, Row, Col, Spin } from "antd";
import { CommonServer } from "./../../server";
import { DollarTwoTone, ContactsTwoTone, InteractionTwoTone, FundTwoTone } from '@ant-design/icons';

const server = CommonServer.Home

export const HomePage = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [statisticData, setStatisticData] = useState<any>({});

  useRequest(server.statistic, {
    onBefore: () => setLoading(true),
    onFinally: () => setLoading(false),
    onError: () => setStatisticData({}),
    onSuccess: (res: any) => {
      setStatisticData(res);
    }
  });


  return (
    <Spin spinning={loading}>
      <Row style={{ width: 900 }} gutter={16}>
        <Col span={8}>
          <Card>
            <h2 className="flex align-center space-center">
              <ContactsTwoTone style={{ fontSize: 36 }} />
              <span className="ml10" style={{ color: "#666" }}>总用户数</span>
            </h2>
            <h1 className="txtc mb0 mt10">{statisticData?.MemberCount}</h1>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <h2 className="flex align-center space-center">
              <DollarTwoTone style={{ fontSize: 36 }} />
              <span className="ml10" style={{ color: "#666" }}>用户钱包总余额</span>
            </h2>
            <h1 className="txtc mb0 mt10">{statisticData?.MemberWalletBalance}</h1>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <h2 className="flex align-center space-center">
              <DollarTwoTone style={{ fontSize: 36 }} />
              <span className="ml10" style={{ color: "#666" }}>总开卡数</span>
            </h2>
            <h1 className="txtc mb0 mt10">{statisticData?.MemberCardNum}</h1>
          </Card>
        </Col>
      </Row>
      <Row style={{ width: 900 }} className="mt20" gutter={16}>
        <Col span={8}>
          <Card>
            <h2 className="flex align-center space-center">
              <FundTwoTone style={{ fontSize: 36 }} />
              <span className="ml10" style={{ color: "#666" }}>用户充值总额</span>
            </h2>
            <h1 className="txtc mb0 mt10">{statisticData?.TotalRecharge}</h1>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <h2 className="flex align-center space-center">
              <InteractionTwoTone style={{ fontSize: 36 }} />
              <span className="ml10" style={{ color: "#666" }}>用户提现总额</span>
            </h2>
            <h1 className="txtc mb0 mt10">{statisticData?.TotalWithdraw}</h1>
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <h2 className="flex align-center space-center">
              <DollarTwoTone style={{ fontSize: 36 }} />
              <span className="ml10" style={{ color: "#666" }}>所有卡片总余额</span>
            </h2>
            <h1 className="txtc mb0 mt10">{statisticData?.CardAvailableBalance}</h1>
          </Card>
        </Col>
      </Row>
    </Spin>
  );
}